var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.ulClass},_vm._l((_vm.items),function(item){return _c('router-link',{key:item.id,staticClass:"nav-item",attrs:{"to":item.link,"tag":"li"},nativeOn:{"click":function($event){return _vm.closeNav($event)}}},[_c('a',{staticClass:"nav-link"},[_vm._v(_vm._s(item.label))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4729677b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.links.vue
// module id = null
// module chunks = 